module.exports = __webpack_public_path__ + "static/media/boursonomic.b532e0f8.png";